import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./Assest/css/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store/store";
import "./Assest/css/responsive.scss";
import "react-loading-skeleton/dist/skeleton.css";
import { UnoStoreHooks } from "@simulanisindia/ui";

const root = ReactDOM.createRoot(document.getElementById("root"));

const { UnoProvider } = UnoStoreHooks;

root.render(
  <React.StrictMode>
    <Provider store={store}>
        <UnoProvider>
          <App />
        </UnoProvider>
    </Provider>
  </React.StrictMode>
);

//
